import React from "react";
import styles from "./footer.css";
export var Footer = function Footer(_ref) {
  var className = _ref.className,
    children = _ref.children;
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: className || styles.container
  }, children);
};